import React from "react";
import { Card } from "react-bootstrap";
import { Link } from "react-router-dom";

export default function index(props) {
  const { item, topPost } = props;

  function setReadableDate(date) {
    const readableDate = new Date(date);
    return readableDate.toDateString();
  }

  return (
    item ? <Card>
      {item.titleImage && (
        <Card.Img className={topPost && "main-page-top-post"} variant="top" onError={() => this} src={item.titleImage} />
      )}
      <Card.Body>
        <Link to={`/article/${item.slug}`} className="card-title h5">{item.title}</Link>
        {item.description && <Card.Text>{item.description}</Card.Text>}
      </Card.Body>
      <Card.Footer>
        <small className="text-muted">
          <Link to={`/user/${item.author.id}`}>{item.author.first_name + " " + item.author.last_name}</Link>
        </small>
        <small className="text-muted d-block">
          {setReadableDate(item.createdAt)}
        </small>
      </Card.Footer>
    </Card> : <div>Loading...</div>
  );
}
